import React, { memo, useCallback } from 'react';
import { CardViewX, CircularProgress, Typography, Icon, Button } from '@ann/web-components';
import {
  CardsContainer,
  EmptyState,
  LoadingContainer,
} from '../SlideoutDrives.styled';

const DriveList = ({
  drives,
  loading,
  selectedDriveIds,
  onDriveClick,
  onDriveSelect,
}) => {
  const handleCheckboxChange = useCallback((driveId) => {
    onDriveSelect?.(driveId);
  }, [onDriveSelect]);

  const handleViewDocuments = useCallback((drive) => {
    onDriveClick?.(drive);
  }, [onDriveClick]);

  if (loading) {
    return (
      <LoadingContainer>
        <CircularProgress size="large" />
      </LoadingContainer>
    );
  }

  if (!drives || drives.length === 0) {
    return (
      <EmptyState>
        <Icon name="folder" size="xl" />
        <Typography category="subtitle" size="medium" weight="bold">
          No drives found
        </Typography>
        <Typography category="body" size="medium" color="body">
          You don't have any drives available.
        </Typography>
      </EmptyState>
    );
  }

  return (
    <CardsContainer>
      {drives.map((drive) => {
        const driveId = drive.vaultUuid || drive.uuid;
        const isSelected = selectedDriveIds.has(driveId);

        return (
          <CardViewX
            key={driveId}
            checked={isSelected}
            isCheckboxable
            onCheckboxChange={() => handleCheckboxChange(driveId)}
            showHover
            size="medium"
          >
            <CardViewX.Header
              icon="folder"
              title={drive.name || 'Unnamed Drive'}
              maxCharacters={40}
            />
            
            {drive.description && (
              <CardViewX.Description maxCharacters={100}>
                {drive.description}
              </CardViewX.Description>
            )}

            <CardViewX.Meta>
              {drive.documentCount !== undefined && (
                <CardViewX.MetaItem
                  icon="description"
                  label={`${drive.documentCount || 0} documents`}
                  tooltipContent="Total documents in this drive"
                />
              )}
              {drive.owner && (
                <CardViewX.MetaItem
                  icon="person"
                  label={drive.owner}
                  tooltipContent="Owner"
                />
              )}
              {drive.created_at && (
                <CardViewX.MetaItem
                  icon="calendarToday"
                  label={new Date(drive.created_at).toLocaleDateString()}
                  tooltipContent="Created date"
                />
              )}
            </CardViewX.Meta>

            <CardViewX.Actions>
            <Button
  icon="arrowRight"
  label=""
  size="medium"
  onClick={() => handleViewDocuments(drive)}
/>

              {/* <CardViewX.PrimaryAction 
               icon="arrowRight"
               label=""
               size="small"
                onClick={() => handleViewDocuments(drive)}
              /> */}
            </CardViewX.Actions>
          </CardViewX>
        );
      })}
    </CardsContainer>
  );
};

DriveList.displayName = 'DriveList';

export default memo(DriveList);

